import { categoryList } from "@/mocks/categories";

export default function Footer() {
  const mainLinks = [
    { name: "Pandabuy Sheet", url: "https://kaspreadsheet.com" },
    { name: "Buy It Now", url: "https://kaspreadsheet.com" },
    { name: "Spreadsheet Guide", url: "/article/pandabuy-spreadsheet-guide" },
  ];

  const guideLinks = [
    { name: "Beginner Guide", url: "/article/pandabuy-spreadsheet-guide" },
    { name: "Safety Tips", url: "/article/pandabuy-spreadsheet-guide" },
    { name: "How to Compare Prices", url: "/article/pandabuy-spreadsheet-guide" },
    { name: "Verified Finds Explained", url: "/article/pandabuy-spreadsheet-guide" },
  ];

  return (
    <footer className="w-full bg-secondary-100">
      <div className="section-container py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[35%]">
            <a href="/" className="inline-block">
              <span className="text-xl md:text-2xl font-heading font-extrabold text-foreground-950 whitespace-nowrap">
                pandabuy<span className="text-primary-500">.guru</span>
              </span>
            </a>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-[340px]">
              Your trusted source for the best pandabuy spreadsheet collections. Curated, verified, and updated weekly. Find streetwear, sneakers, accessories, and more.
            </p>

            <div className="mt-8">
              <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-3">Stay Updated</p>
              <form
                data-readdy-form="true"
                action="https://readdy.ai/api/form/d91769s6ci2plld1ojr0"
                method="POST"
                className="flex flex-col sm:flex-row gap-3"
              >
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email"
                  className="px-4 py-3 rounded-xl border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 transition-colors flex-1"
                  required
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  className="spam-shield"
                />
                <button
                  type="submit"
                  className="px-5 py-3 rounded-xl bg-primary-500 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
                >
                  Subscribe
                </button>
              </form>
            </div>
          </div>

          <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                Quick Links
              </h4>
              <ul className="space-y-3">
                {mainLinks.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.url}
                      {...(link.url.startsWith("http") ? { target: "_blank", rel: "noopener nofollow" } : {})}
                      className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                Guides
              </h4>
              <ul className="space-y-3">
                {guideLinks.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.url}
                      className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-4">
                Categories
              </h4>
              <ul className="space-y-2.5">
                {categoryList.slice(0, 8).map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-700 hover:text-foreground-950 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 pandabuy.guru. All rights reserved.
          </p>
          <p className="text-xs text-foreground-400">
            This site is an independent guide and is not affiliated with Pandabuy.
          </p>
        </div>
      </div>
    </footer>
  );
}